import { render, staticRenderFns } from "./LinkRelationshipModal.vue?vue&type=template&id=30e787f8"
import script from "./LinkRelationshipModal.vue?vue&type=script&lang=js"
export * from "./LinkRelationshipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports